var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { projectDisplay: true, eventBodyBelow: _vm.eventBodyBelow } },
    [
      _c("ControlBar", {
        attrs: {
          projectName: _vm.projectName,
          selectedFolderId: _vm.selectedFolderId,
          uniqueOnly: _vm.uniqueOnly
        }
      }),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
        : _vm.loading
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("ScaleLoader"), _vm._v(" Loading…")],
            1
          )
        : _c(
            "div",
            { staticClass: "body", style: _vm.bodyStyle },
            [
              _c(
                "div",
                {
                  staticClass: "folderBrowserContainer",
                  style: _vm.folderBrowserStyle,
                  attrs: { tabindex: "0" },
                  on: { keydown: _vm.onFolderBrowserKeydown }
                },
                [
                  _c("FolderBrowser", {
                    attrs: {
                      projectName: _vm.projectName,
                      selectedFolderId: _vm.selectedFolderId,
                      searchArgs: _vm.searchArgs
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("ResizeBar", {
                attrs: { min: 50, max: 600, start: _vm.fbStart, default: 250 },
                on: { change: _vm.fbChange }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "eventBrowserContainer",
                  style: _vm.eventBrowserStyle,
                  attrs: { tabindex: "0" },
                  on: { keydown: _vm.onEventBrowserKeydown }
                },
                [
                  _c("EventBrowser", {
                    ref: "eventBrowser",
                    attrs: {
                      projectName: _vm.projectName,
                      selectedFolderId: _vm.selectedFolderId,
                      selectedEventIds: _vm.selectedEventIds,
                      searchArgs: _vm.searchArgs,
                      openedEventId: _vm.openedEventId,
                      uniqueOnly: _vm.uniqueOnly
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              !_vm.eventBodyBelow
                ? _c("ResizeBar", {
                    attrs: {
                      min: 100,
                      max: 800,
                      start: _vm.ebStart,
                      default: 400,
                      offset: _vm.fbStart
                    },
                    on: { change: _vm.ebChange }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.eventBodyBelow
                ? _c(
                    "div",
                    { staticClass: "eventDetailsContainer" },
                    [
                      _c("EventDetails", {
                        attrs: {
                          projectName: _vm.projectName,
                          openedEventId: _vm.openedEventId,
                          selectedFolderId: _vm.selectedFolderId,
                          uniqueOnly: _vm.uniqueOnly
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
      _vm._v(" "),
      _vm.eventBodyBelow
        ? _c("ResizeBar", {
            attrs: {
              horizontal: true,
              min: 100,
              max: 1800,
              start: _vm.tbStart,
              default: 400
            },
            on: { change: _vm.tbChange }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.eventBodyBelow
        ? _c(
            "div",
            {
              staticClass: "eventDetailsContainer",
              style: _vm.eventDetailsStyle
            },
            [
              _c("EventDetails", {
                attrs: {
                  projectName: _vm.projectName,
                  openedEventId: _vm.openedEventId,
                  selectedFolderId: _vm.selectedFolderId,
                  uniqueOnly: _vm.uniqueOnly
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }